/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentCloudHostingPlanCard from './index/current-cloud-hosting-plan-card';
import { hasScheduledChanges } from 'state/current-cloud-hosting/selectors';
import ScheduledChangesCard from './index/scheduled-changes';
import CloudHostingDetailsCard from './index/cloud-hosting-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const CloudHosting = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Cloud Hosting Plan - Tower Systems' />
            <Topbar title='Cloud Hosting Plan' subTitle='Manage your cloud hosting plan' selected='cloud-hosting'>

            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current cloud hosting plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentCloudHostingPlanCard />
                            {props.hasScheduledChanges && <ScheduledChangesCard />}
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(CloudHosting);
